<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default
{
    name: 'mv-media-form',

    props:
    {
        model: Object,
        edit: Boolean,
    },

    computed:
    {
        ...mapGetters({
            locale: 'generalCurrentLocale',
        }),

    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

        addVideo(file)
        {
            this.model.videos.push(file)
        },

        removeVideo(file)
        {
            axios.delete(`${process.env.API_URL}/v1/admin/video/${file.id}`).then(res => {
                for (let i = 0; i < this.model.videos.length; ++i)
                {
                    const item = this.model.videos[i]
                    if (file.id == item.id)
                    {
                        this.model.videos.splice(i, 1)
                    }
                }
            })
        }

    },

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.TITLE') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.title">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.IMAGES') }}
            </label>
            <div class="col-md-6">
                <mv-image-uploader ref="uploader" multiple @upload-done="addFile($event)" accept="image/*" :width="1280" :height="720" :quality="3"></mv-image-uploader>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">

            </div>
            <div class="col-md-6">
                <mv-attachment v-for="img in model.attachments" :key="img.id" :attachment="img" can-remove @remove="removeFile">
                </mv-attachment>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">
                <label>
                    {{ $t('GENERAL.VIDEO') }}
                </label>
            </div>
            <div class="col-md-6">
                <mv-video @upload-done="addVideo($event)">
                </mv-video>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">

            </div>
            <div class="col-md-6">
                <div v-for="video in model.videos" :key="video.id" class="row">
                    <div class="col-sm-10">
                        <iframe  width="320" height="160" :src="'https://www.youtube.com/embed/' + video.video" allowFullScreen="true">

                        </iframe>
                    </div>
                    <div class="col-sm-2 vertical-align-video" @click.prevent.stop="removeVideo(video)">
                        <button class="btn btn-danger btn-xs">&times;</button>
                    </div>
                </div>
            </div>

        </div>
    </form>
</div>
</template>

<style>
.vertical-align-video {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 160px;
}

</style>


// WEBPACK FOOTER //
// src/components/forms/MediaForm.vue